// extracted by mini-css-extract-plugin
export var confirmIcon = "HubspotFormV2-module--confirmIcon--6llMr";
export var confirmationPage = "HubspotFormV2-module--confirmationPage--boM79";
export var consentCheckBox = "HubspotFormV2-module--consentCheckBox--G-BmV";
export var consentContainer = "HubspotFormV2-module--consentContainer--RUiML";
export var consentField = "HubspotFormV2-module--consentField--o82hH";
export var errorBox = "HubspotFormV2-module--errorBox--59Rtr";
export var errorMsg = "HubspotFormV2-module--errorMsg--suCqB";
export var errorStyles = "HubspotFormV2-module--errorStyles--VPl09";
export var fieldGroup = "HubspotFormV2-module--fieldGroup--wiyoE";
export var fieldsContainer = "HubspotFormV2-module--fieldsContainer--Eznem";
export var mainCopy = "HubspotFormV2-module--mainCopy--5A+7m";
export var page404Title = "HubspotFormV2-module--page404-title--vCVdP";
export var recaptcha = "HubspotFormV2-module--recaptcha--6TopF";
export var submitButton = "HubspotFormV2-module--submitButton--XB4ce";
export var textInput = "HubspotFormV2-module--textInput--o3QOw";